<template>
  <div>
    <card class="profile-section">
      <div class="profile-wrapper">
        <div class="profile-picture">
          <img v-if= "ProfileInfo.BusinessUnitId==1" src="../assets/images/logo.svg" alt />
          <img v-if= "ProfileInfo.BusinessUnitId==2" src="../assets/images/logo-axesa.svg" alt />
          <img v-if= "ProfileInfo.BusinessUnitId==3" src="../assets/images/logo-ip.svg" alt />
        </div>
        <h3>{{ ProfileInfo.Name }}</h3>
        <p>20 años con nosotros</p>
      </div>
      <form>
        <div class="two-colum-form">
          <div class="form-group">
            <label for="nameInput">Nombre del negocio</label>
            <input
              type="text"
              id="nameInput"
              placeholder="Ej: Caribe Media"
              :value="ProfileInfo.Name"
              readonly
            />
          </div>
          <div class="form-group">
            <label for="emailinput">Correo Electrónico</label>
            <input
              type="email"
              id="emailinput"
              placeholder="Ej: nombre@pcaribemedia.com"
              :value="ProfileInfo.MainEmail"
              readonly
            />
          </div>
          <div class="form-group">
            <label for="phoneInput">Teléfono</label>
            <input
              type="tel"
              id="phoneInput"
              placeholder="Ej: 809-123-4567"
              :value="ProfileInfo.Phone"
              readonly
            />
          </div>
          <div class="form-group">
            <label for="userID">ID</label>
            <input
              type="number"
              id="userID"
              placeholder="Ej: 8715"
              :value="ProfileInfo.SubscrId"
              readonly
            />
          </div>
          <div class="form-group">
            <label for="rnc">RNC</label>
            <input
              type="string"
              id="rnc"
              placeholder="Ej: 000000"
              :value="ProfileInfo.RNC"
              readonly
            />
          </div>
          <div class="form-group">
            <label for="userNameInput">Nombre de usuario</label>
            <input
              type="text"
              id="userNameInput"
              placeholder="Ej: caribemedia"
              :value="ProfileInfo.UserName"
              readonly
            />
          </div>
          <div class="form-group">
            <label for="rnc">Estado</label>
            <select v-model="UserInfoUpdate.Status" name="select">
              <option :value="true"> Activo</option>
              <option :value="false"> Inactivo</option>
            </select>
          </div>
        </div>
        <div class="products">
          <h2>Productos</h2>
          <el-collapse v-model="activeNames" @change="handleChange">
            <el-collapse-item
              title="Anuncios de Google (Busqueda, Display, Redes sociales)"
              name="1"
            >
              <div class="two-colum-form">
                <div class="form-group">
                  <label for="searchAdsID">Google Ads ID</label>
                  <input
                    type="text"
                    id="searchAdsID"
                    v-model="ProfileInfo.GoogleAdsID"
                    maxlength="10"
                  />
                </div>
              </div>
            </el-collapse-item>
            <!-- <el-collapse-item title="Anuncios de YouTube" name="3">
              <div class="two-colum-form">
                <div class="form-group">
                  <label for="youtubeURL">URL Destino</label>
                  <input type="text" id="youtubeURL" :value="ProfileInfo.AnalyticsUrl" readonly />
                </div>
                <div class="form-group">
                  <label for="youtubeAdsID">Google Ads ID</label>
                  <input type="text" id="youtubeAdsID" :value="ProfileInfo.GoogleAdsID" readonly />
                </div>
              </div>
            </el-collapse-item> -->

            <el-collapse-item title="Su Website" name="4">
              <div class="two-colum-form">
                <div class="form-group">
                  <label for="searchURL">URL</label>
                  <input
                    type="text"
                    id="searchURL"
                    v-model="ProfileInfo.AnalyticsUrl"
                  />
                </div>
              </div>
            </el-collapse-item>

            <el-collapse-item
              title="Anuncios de Facebook (Social Media, Redes Sociales)"
              name="5"
            >
              <div class="two-colum-form">
                <div class="form-group">
                  <label for="adsFacebookAccountId"
                    >Facebook Ads Account Id</label
                  >
                  <input
                    type="text"
                    id="adsFacebookAccountId"
                    v-model="ProfileInfo.FacebookAdsId"
                  />
                </div>
              </div>
            </el-collapse-item>
            <el-collapse-item
              title="Google My Business"
              name="GMB"
            >
              <div class="two-colum-form">
                <div class="form-group">
                  <label for="adsGoogleMyBusiness"
                    >Google My Business Account ID</label
                  >
                  <input
                    type="text"
                    id="adsGmbProfileId"
                    v-model="ProfileInfo.googleMyBusinessProfileId"
                  />
                </div>
              </div>
            </el-collapse-item>
            <el-collapse-item
              title="Tiktok"
              name="tiktok"
            >
              <div class="two-colum-form">
                <div class="form-group">
                  <label for="adsTiktok"
                    >Tiktok Account ID</label
                  >
                  <input
                    type="text"
                    id="accountTiktokId"
                    v-model="ProfileInfo.TiktokProfileId"
                  />
                </div>
              </div>
            </el-collapse-item>
            <el-collapse-item
              title="Spotify Ads Account"
              name="Spotify"
            >
              <div class="two-colum-form">
                <div class="form-group">
                  <label for="spotifyAds"
                    >Spotify Account ID</label
                  >
                  <input
                    type="text"
                    id="adsSpotifyProfileId"
                    v-model="ProfileInfo.spotifyAccountId"
                  />
                </div>
              </div>
            </el-collapse-item>
            <el-collapse-item
              title="Linkedin Ads Account"
              name="Linkedin"
            >
              <div class="two-colum-form">
                <div class="form-group">
                  <label for="linkedinAds"
                    >Linkedin Account ID</label
                  >
                  <input
                    type="text"
                    id="adsLinkedinProfileId"
                    v-model="ProfileInfo.linkedinAccountId"
                  />
                </div>
              </div>
            </el-collapse-item>
            <!-- <el-collapse-item
              v-if="ProfileInfo.BusinessUnitId == 3"
              title="Infopaginas Metrics Client ID"
              name="Infopaginas"
            >
              <div class="two-colum-form">
                <div class="form-group">
                  <label for="infopaginasMetrics"
                    >Infopaginas Metrics Client ID</label
                  >
                  <input
                    type="text"
                    id="infopaginasMetrics"
                    v-model="ProfileInfo.infopaginasClientId"
                  />
                </div>
              </div>
            </el-collapse-item> -->
          </el-collapse>
        </div>
        <button class="btn btn-primary" type="button" @click="UPDATE">
          GUARDAR CAMBIOS
        </button>
      </form>
    </card>
    <card class="profile-section mt-2 mb-5">
      <form>
        <div class="two-colum-form">
          <div class="form-group">
            <label for="pass">PASSWORD</label>
            <input
              type="string"
              id="pass"
              :placeholder="`Ej: ${ProfileInfo.Name.toLowerCase().split(' ').join('')}123*1`"
              v-model="UserPasswordUpdate.Password"
            />
          </div>
          <div class="form-group box-change-password">
            <button
              class="btn btn-primary"
              type="button"
              @click="CHANGEPASSWORD"
            >
              RESETEAR CONTRASEÑA
            </button>
          </div>
        </div>
      </form>
    </card>
  </div>
</template>
<script>
import InfoProfile from "../services/Fase2/profile";
import Swal from "sweetalert2";

export default {
  name: "profile",
  data() {
    return {
      userStatus: false,
      ProfileInfo: {
        AnalyticsUrl: "",
        FacebookAdsId: "",
        GoogleAdsID: "",
        MainEmail: "",
        Name: "",
        Phone: "",
        RNC: "",
        SubscrId: "",
        UserName: "",
        BusinessUnitId: "",
        Status: "",
        googleMyBusinessProfileId: "",
        spotifyAccountId: "",
        linkedinAccountId: "",
        TiktokProfileId:"",
      },
      activeNames: [""],
      UserId: 0,
      UserInfoUpdate: {
        UserName: "",
        Status: true
      },
      UserPasswordUpdate: {
        Password: ""
      }
    };
  },
  async created() {
    const { subscriberId, businessUnitId } = this.$route.params;

    const profile = await new InfoProfile(this).getProfile(
      subscriberId,
      businessUnitId
    );

    const userInfo = await new InfoProfile(this).getUserInfo(subscriberId, businessUnitId);
    this.ProfileInfo = profile;
    this.UserId = userInfo.UserId;
    this.ProfileInfo.BusinessUnitId = businessUnitId;
    this.ProfileInfo.googleMyBusinessProfileId = profile.account_gmb_id;
    this.ProfileInfo.spotifyAccountId = profile.SpotifyAccountId;
    this.ProfileInfo.linkedinAccountId = profile.LinkedinAccountId;
    this.ProfileInfo.TiktokProfileId = profile.TiktokID;
    // this.ProfileInfo.infopaginasClientId = profile.InfopaginasClientId;

    const isClientActive = userInfo ? userInfo.Status : false;

    if (profile != null) {
      this.UserInfoUpdate.UserName = this.ProfileInfo.UserName;
      this.UserInfoUpdate.Email = this.ProfileInfo.MainEmail;
      this.UserInfoUpdate.Status = isClientActive;
    }
  },
  methods: {
    UPDATE: async function() {
      const { subscriberId, businessUnitId } = this.$route.params;

      const searchAdsID = document.getElementById("searchAdsID").value;
      const adsFacebookAccountId = document.getElementById(
        "adsFacebookAccountId"
      ).value;
      const searchURL = document.getElementById("searchURL").value;
      const userNameInput = document.getElementById("userNameInput").value;
      const profileGMBAccountId = document.getElementById("adsGmbProfileId").value;
      const spotifyAccountId = document.getElementById("adsSpotifyProfileId").value;
      const linkedinAccountId = document.getElementById("adsLinkedinProfileId").value;
      const accountTiktokId = document.getElementById("accountTiktokId").value;
      // const infopaginasClientId = document.getElementById("infopaginasMetrics").value;

      const obj = {
        accountGoogleId: searchAdsID,
        accountFacebookId: adsFacebookAccountId,
        googleAnalyticsUrl: searchURL,
        userName: userNameInput,
        profileGMBAccountId,
        spotifyAccountId,
        linkedinAccountId,
        accountTiktokId
        // infopaginasClientId
      };

      this.UserInfoUpdate.UserName = userNameInput;
      if (this.UserInfoUpdate.UserName) {
        await new InfoProfile(this).updateUser( this.UserId, this.UserInfoUpdate );
      }

      const upInfo = await new InfoProfile(this).updateProfile(
        obj,
        subscriberId,
        businessUnitId
      );

      if (upInfo === 200) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Registro actualizado",
          showConfirmButton: false,
          timer: 1500
        });
      } else {
        Swal.fire({
          position: "center",
          icon: "error",
          title: "No fue posible actualizar el registro",
          showConfirmButton: false,
          timer: 1500
        });
      }
    },
    handleChange(val) {
      console.log(val);
    },
    CHANGEPASSWORD: async function() {
      let userUpdateMessage;

      if (this.UserPasswordUpdate.Password) {
        const userID = this.UserId;
        const userUpdateDataInfo = this.UserPasswordUpdate;
        userUpdateMessage = await new InfoProfile(this).updateUserPassword(userID,userUpdateDataInfo);
      }

      if (userUpdateMessage.status != 200) {
        Swal.fire(
          `${userUpdateMessage.statusText}`,
          'Ocurrio un error!',
          'error'
          )
      }else{
        Swal.fire(
          `${userUpdateMessage.statusText}`,
          '¡Cambio de contraseña correcto!',
          'success'
          )
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.status-active{
  color: #119131;
  border: 2px solid #119131;
  font-weight: 600;
}

.status-inactive{
  color: #af0f0f;
  border: 2px solid #af0f0f;
  font-weight: 600;
}

.profile-section {
  max-width: 1000px;
  margin: 0 auto;
}
.profile-wrapper {
  text-align: center;
  padding-bottom: 20px;
  margin-bottom: 20px;
  border-bottom: 1px solid $blueish-gray-200;
}
.profile-picture {
  width: 80px;
  height: 80px;
  border-radius: 80px;
  border: 1px solid $blueish-gray-300;
  background-color: $blueish-gray-200;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  margin: 0 auto;

  img {
    width: 100%;
    object-fit: cover;
  }
}
.mb-5{
  margin-bottom: 50pxy;
}
.box-change-password{
  display: flex;
  align-items: center;
  margin-bottom: 0px !important;
}

.mt-2{
  margin-top: 30px;
}

.products {
  margin-top: 20px;
}

[readonly]{
  background-color: #f6f6f6;
  color: #797979;
  border-color: #c8c8c8;
}

@include respond-above(md) {
  .two-colum-form {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 20px;
  }
  .products {
    margin-bottom: 30px;
    h2 {
      margin-bottom: 20px;
    }
  }
}
</style>
